import { gql } from '@apollo/client';

export const FETCH_EDITOR_SYMBOLS_DEFAULT = gql`
  query fetchEditorSymbolsDefault($order: [Editor_symbols_defaultOrder!]) {
    editor_symbols_defaults(order: $order) {
      edges {
        node {
          objectId
          order
          img {
            url
            name
          }
        }
      }
    }
  }
`;
